import React, {useEffect, useState, ChangeEvent} from 'react';
import styles from "./strategies.module.scss";
import {Button, Input, Select, Switch, SelectProps, message as messageAnt} from "antd";
import {useSettings} from "../../hooks/settings.hook";
import {IElemAllStrategyTransform, IStrategiesInfo} from "../../shared/types";
import {transformAllSettings} from "../../shared/lib/lib";

const Strategies = () => {

  const {loading: loadingSettings, getSettingsByStrategyList, saveSettingsForStrategy, getAllStrategiesInfo, error: errorSettings, clearError: clearErrorSettings} = useSettings()

  const [strategiesInfo, setStrategiesInfo] = useState<IStrategiesInfo | undefined>()
  const [optionsSelectStrategyForEnable, setOptionsSelectStrategyForEnable] = useState<SelectProps['options']>()
  const [strategyForEnable, setStrategyForEnable] = useState<string | undefined>()
  const [strategyIsEnable, setStrategyIsEnable] = useState<boolean | undefined>(false)
  const [allSettings, setAllSettings] = useState<Record<string, IElemAllStrategyTransform> | undefined>()//ключ стратегия
  const [optionsSelectStrategyForSetting, setOptionsSelectStrategyForSetting] = useState<SelectProps['options']>()
  const [strategyForSetting, setStrategyForSetting] = useState<string | undefined>()
  const [saveSettingsBtnDisabled, setSaveSettingsBtnDisabled] = useState(true)

  //функция получение информации по существующим стратегиям
  const getStrategiesInfo = async () => {
    try {
      const data = await getAllStrategiesInfo()
      messageAnt.info(data.message)
      return data.info
    } catch (e) {
      messageAnt.info(errorSettings);
      clearErrorSettings()
      return undefined
    }
  }

  //получение информации по существующим стратегиям
  useEffect(() => {
    const get = async () => {
      const info = await getStrategiesInfo()
      setStrategiesInfo(info)
    }
    get()
  }, [])

  //поля тонких настроек актуальных для выбранной стратегии
  const [setting0, setSetting0] = useState<string>('')
  const [setting1, setSetting1] = useState<string>('')
  const [setting2, setSetting2] = useState<string>('')
  const [setting3, setSetting3] = useState<string>('')
  const [setting4, setSetting4] = useState<string>('')
  const [setting5, setSetting5] = useState<string>('')
  const [setting6, setSetting6] = useState<string>('')
  const [setting7, setSetting7] = useState<string>('')
  const [setting8, setSetting8] = useState<string>('')
  const [setting9, setSetting9] = useState<string>('')
  const [setting10, setSetting10] = useState<string>('')
  const [setting11, setSetting11] = useState<string>('')
  const [setting12, setSetting12] = useState<string>('')
  const [setting13, setSetting13] = useState<string>('')
  const [setting14, setSetting14] = useState<string>('')
  const [setting15, setSetting15] = useState<string>('')
  const [setting16, setSetting16] = useState<string>('')
  const [setting17, setSetting17] = useState<string>('')
  const [setting18, setSetting18] = useState<string>('')
  const [setting19, setSetting19] = useState<string>('')

  //формирование списка для селектора выбора стратегии для подключения/отключения
  useEffect(() => {
    if (strategiesInfo) {
      const optionsStrategy: SelectProps['options'] = []
      Object.keys(strategiesInfo).forEach((strategy) => {
        const value = strategy
        const label = strategiesInfo[strategy].label
        optionsStrategy.push({value: value, label: label})
      })
      setOptionsSelectStrategyForEnable(optionsStrategy)
    }
  }, [strategiesInfo])

  //выбор стратегии для подключения/отключения
  const onChangeStrategyForEnable = (value: string) => {
    setStrategyForEnable(value)
  };

  //установка флага, подключена ли стратегия в работу, информация из БД
  useEffect(() => {
    if (allSettings && strategyForEnable) {
      const isEnable = allSettings[strategyForEnable]?.enable
      setStrategyIsEnable(isEnable)
    }
  }, [allSettings, strategyForEnable])

  //сохранение настроек стратегии в БД
  const saveSettings = async (strategy: string, enable: boolean, settings: string) => {
    try {
      const data = await saveSettingsForStrategy(strategy, enable, settings)
      messageAnt.info(data.message)
    } catch (e) {
      messageAnt.info(errorSettings);
      clearErrorSettings()
    }
  }

  //получение точных настроек для всех стратегий из БД
  const getSettings = async (strategies: string[]) => {
    try {
      const data = await getSettingsByStrategyList(strategies)
      messageAnt.info(data.message)
      const settings = transformAllSettings(data.info)
      return settings
    } catch (e) {
      messageAnt.info(errorSettings);
      clearErrorSettings()
      return undefined
    }
  }

  //изначальное получение настроек для стратегий с сервера
  useEffect(() => {
    if (strategiesInfo) {
      const get = async () => {
        const strategies = Object.keys(strategiesInfo)
        const settings = await getSettings(strategies)
        setAllSettings(settings)
      }
      get()
    }
  }, [strategiesInfo])

  //подключение/отключение выбранной стратегии в работу
  const onChangeEnableStrategy = async (checked: boolean) => {
    if (strategiesInfo && strategyForEnable) {
      const enable = checked
      setStrategyIsEnable(enable)
      const strategy = strategyForEnable
      const settingsString = (allSettings && allSettings[strategyForEnable] && allSettings[strategyForEnable]?.settings) ? allSettings[strategyForEnable].settings : ''
      await saveSettings(strategy, enable, settingsString)
      const strategies = Object.keys(strategiesInfo)
      const settingsNew = await getSettings(strategies)
      setAllSettings(settingsNew)
    }
  };

  //формирование списка для селектора выбора стратегии для настройки стратегии. В списке будут только подключенные в работу стратегии.
  useEffect(() => {
    if (strategiesInfo) {
      const optionsStrategy: SelectProps['options'] = []
      if (allSettings) {
        Object.keys(allSettings).forEach((sett) => {
          if (allSettings[sett as keyof typeof allSettings].enable) {
            optionsStrategy.push({
              value: sett,
              label: strategiesInfo[sett].label
            })
          }
        })
      }
      setOptionsSelectStrategyForSetting(optionsStrategy)
    }
  }, [strategiesInfo, allSettings])

  //выбор стратегии для настройки из списка активных
  const onChangeStrategyForSetting = (value: string) => {
    setStrategyForSetting(value)
  };

  //изначальное заполнение полей настроек выбранной для настройки стратегии
  useEffect(() => {
    if (strategiesInfo && allSettings && strategyForSetting) {
      let sett0 = ''
      let sett1 = ''
      let sett2 = ''
      let sett3 = ''
      let sett4 = ''
      let sett5 = ''
      let sett6 = ''
      let sett7 = ''
      let sett8 = ''
      let sett9 = ''
      let sett10 = ''
      let sett11 = ''
      let sett12 = ''
      let sett13 = ''
      let sett14 = ''
      let sett15 = ''
      let sett16 = ''
      let sett17 = ''
      let sett18 = ''
      let sett19 = ''
      if (allSettings[strategyForSetting].settings !== '') {
        sett0 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[0]]
        sett1 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[1]]
        sett2 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[2]]
        sett3 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[3]]
        sett4 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[4]]
        sett5 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[5]]
        sett6 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[6]]
        sett7 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[7]]
        sett8 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[8]]
        sett9 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[9]]
        sett10 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[10]]
        sett11 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[11]]
        sett12 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[12]]
        sett13 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[13]]
        sett14 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[14]]
        sett15 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[15]]
        sett16 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[16]]
        sett17 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[17]]
        sett18 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[18]]
        sett19 = JSON.parse(allSettings[strategyForSetting].settings)[Object.keys(strategiesInfo[strategyForSetting].settings)[19]]
      }
      setSetting0(sett0)
      setSetting1(sett1)
      setSetting2(sett2)
      setSetting3(sett3)
      setSetting4(sett4)
      setSetting5(sett5)
      setSetting6(sett6)
      setSetting7(sett7)
      setSetting8(sett8)
      setSetting9(sett9)
      setSetting10(sett10)
      setSetting11(sett11)
      setSetting12(sett12)
      setSetting13(sett13)
      setSetting14(sett14)
      setSetting15(sett15)
      setSetting16(sett16)
      setSetting17(sett17)
      setSetting18(sett18)
      setSetting19(sett19)
    }
  }, [strategiesInfo, allSettings, strategyForSetting])

  //изменение настроек у выбранной для настройки стратегии
  const changeSetting0Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting0(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting1Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting1(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting2Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting2(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting3Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting3(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting4Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting4(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting5Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting5(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting6Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting6(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting7Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting7(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting8Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting8(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting9Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting9(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting10Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting10(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting11Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting11(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting12Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting12(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting13Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting13(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting14Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting14(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting15Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting15(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting16Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting16(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting17Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting17(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting18Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting18(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }
  const changeSetting19Handler = (e: ChangeEvent<HTMLInputElement>) => {
    setSetting19(e.target.value)
    setSaveSettingsBtnDisabled(false)
  }

  //сохранение изменений настроек для выбранной для настройки стратегии
  const saveSettingsHandler = async () => {
    if (strategiesInfo && strategyForSetting && allSettings) {
      const enable = allSettings[strategyForSetting].enable
      const strategy = strategyForSetting
      const settingsString = JSON.stringify({
        [Object.keys(strategiesInfo[strategyForSetting].settings)[0]]: setting0,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[1]]: setting1,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[2]]: setting2,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[3]]: setting3,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[4]]: setting4,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[5]]: setting5,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[6]]: setting6,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[7]]: setting7,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[8]]: setting8,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[9]]: setting9,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[10]]: setting10,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[11]]: setting11,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[12]]: setting12,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[13]]: setting13,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[14]]: setting14,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[15]]: setting15,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[16]]: setting16,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[17]]: setting17,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[18]]: setting18,
        [Object.keys(strategiesInfo[strategyForSetting].settings)[19]]: setting19,
      })
      await saveSettings(strategy, enable, settingsString)
      const strategies = Object.keys(strategiesInfo)
      const settingsNew = await getSettings(strategies)
      setAllSettings(settingsNew)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          {/*//@ts-ignore*/}
          <p className={styles.title}>{"Стратегии"}</p>
        </div>
        <div className={styles.table}>
          <h5>{"Настройки стратегий"}</h5>
          <div className={[styles.enable, styles.blockWrap].join(' ')}>
            <p className={styles.title}>{'Подключение стратегий'}</p>
            <Select
              showSearch
              allowClear
              placeholder={'К подключению'}
              onChange={onChangeStrategyForEnable}
              options={optionsSelectStrategyForEnable} style={{width: '100%'}}
              size={"small"}
            />
            {
              strategyForEnable &&
              <div className={styles.label}>
                <Switch size="small" onChange={onChangeEnableStrategy} checked={strategyIsEnable}/>
                {
                  strategyIsEnable ?
                    <p>Стратегия подключена</p> :
                    <p>Стратегия отключена</p>
                }
              </div>
            }
          </div>
          <div className={[styles.activeStrategy, styles.blockWrap].join(' ')}>
            <p className={styles.title}>{'Настройки активных стратегий'}</p>
            <Select
              showSearch
              allowClear
              placeholder={'Активные'}
              onChange={onChangeStrategyForSetting}
              options={optionsSelectStrategyForSetting} style={{width: '100%'}}
              size={"small"}
            />
            {
              strategiesInfo && strategyForSetting
              &&
              <div className={styles.settingsWrap}>
                <div className={styles.settings}>
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[0]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[0]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[0]]}
                          value={setting0}
                          onChange={changeSetting0Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[1]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[1]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[1]]}
                          value={setting1}
                          onChange={changeSetting1Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[2]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[2]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[2]]}
                          value={setting2}
                          onChange={changeSetting2Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[3]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[3]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[3]]}
                          value={setting3}
                          onChange={changeSetting3Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[4]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[4]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[4]]}
                          value={setting4}
                          onChange={changeSetting4Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[5]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[5]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[5]]}
                          value={setting5}
                          onChange={changeSetting5Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[6]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[6]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[6]]}
                          value={setting6}
                          onChange={changeSetting6Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[7]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[7]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[7]]}
                          value={setting7}
                          onChange={changeSetting7Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[8]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[8]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[8]]}
                          value={setting8}
                          onChange={changeSetting8Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[9]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[9]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[9]]}
                          value={setting9}
                          onChange={changeSetting9Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[10]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[10]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[10]]}
                          value={setting10}
                          onChange={changeSetting10Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[11]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[11]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[11]]}
                          value={setting11}
                          onChange={changeSetting11Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[12]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[12]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[12]]}
                          value={setting12}
                          onChange={changeSetting12Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[13]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[13]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[13]]}
                          value={setting13}
                          onChange={changeSetting13Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[14]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[14]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[14]]}
                          value={setting14}
                          onChange={changeSetting14Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[15]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[15]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[15]]}
                          value={setting15}
                          onChange={changeSetting15Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[16]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[16]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[16]]}
                          value={setting16}
                          onChange={changeSetting16Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[17]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[17]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[17]]}
                          value={setting17}
                          onChange={changeSetting17Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[18]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[18]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[18]]}
                          value={setting18}
                          onChange={changeSetting18Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                  {
                    strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[19]] &&
                    <div className={styles.wrap}>
                      <label
                        htmlFor="">{strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[19]]}</label>
                      <div className={styles.input}>
                        <Input
                          placeholder={strategiesInfo[strategyForSetting].settings[Object.keys(strategiesInfo[strategyForSetting].settings)[19]]}
                          value={setting19}
                          onChange={changeSetting19Handler}
                          style={{width: 60}}
                          size={"small"}
                        />
                      </div>
                    </div>
                  }
                </div>
                <Button title={'Сохранить'} type={'primary'} onClick={saveSettingsHandler}
                        size={'small'} shape={"round"} disabled={saveSettingsBtnDisabled}>Сохранить</Button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Strategies;